import { publicFaultScan, publicFaultLookup, getPublicFaultQrConfig } from "../app/UrlCrud";

let cachedBase;

// Resolvers for the unauthenticated fault portal. They talk only to the public,
// owner-scoped endpoints and return the minimal asset context for the form.
export const publicFaultScanRequest = ownerId => ({
    resolveToken: token => publicFaultScan(token, ownerId),
    lookupAssetId: assetID => publicFaultLookup(assetID, ownerId),
    loadBaseUrl: () =>
        cachedBase !== undefined
            ? Promise.resolve(cachedBase)
            : getPublicFaultQrConfig()
                  .then(({ data }) => (cachedBase = (data && data.publicBaseUrl) || null))
                  .catch(() => null)
});
